import { Component } from '@nicolas-riciotti/light2'

export default class WaitlistModale extends Component {

    async onFormSubmit(e) {
        if (e) e.preventDefault();

        const formData = new FormData(this.$waitlistForm);

        // Ensure required fields exist + add the WP AJAX action
        formData.set('action', 'add_waitlist');

        // Optional: trim email/location if your inputs are named "email"/"location"
        const email = (formData.get('email') || '').toString().trim();
        const location = (formData.get('location') || '').toString().trim();
        formData.set('email', email);
        formData.set('location', location);

        if (window.clarity) {
            window.clarity('set', 'waitlist', 'send');
        }

        try {
            const res = await fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Accept': 'application/json',
                },
                body: new URLSearchParams([...formData.entries()]).toString(),
            });

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`);
            }
            const data = await res.json();

            if (data?.success) {
                this.updateFormStep('success');
            } 
            else {
                this.updateFormStep('error');
            }
        } 
        catch (err) {
            this.updateFormStep('error');
        }
    }

    updateFormStep(currentStep) {
       this.$waitlistModaleSteps?.forEach($el => {
            $el.style.display = currentStep === $el.getAttribute('step') ? 'flex' : 'none';
        });
    }

    created() {
        this.isModaleOpened = false;
    }

    _buildIframeUrl() {
        const iframe = this.querySelector('iframe[data-base-url]');
        if (!iframe || iframe.src) return;

        const baseUrl = iframe.dataset.baseUrl;
        const params = new URLSearchParams();

        // Grab ocid from current page URL
        // const pageParams = new URLSearchParams(window.location.search);
        // const ocid = pageParams.get('ocid');
        // if (ocid) params.set('ocid', ocid);
        const pageParams = new URLSearchParams(window.location.search);
        let ocid = null;
        for (const [key, value] of pageParams.entries()) {
            if (key.toLowerCase() === 'ocid') {
                ocid = value;
                break;
            }
        }
        if (ocid) params.set('ocid', ocid);


        // Read consent from Microsoft UHF cookie banner
        const consent = typeof siteConsent !== 'undefined' ? siteConsent.getConsent() : {};
        params.set('R', consent.Required !== false ? '1' : '0');
        params.set('A', consent.Analytics ? '1' : '0');
        params.set('S', consent.SocialMedia ? '1' : '0');
        params.set('Ad', consent.Advertising ? '1' : '0');

        // GPC (Global Privacy Control) from browser
        params.set('GPC', navigator.globalPrivacyControl ? '1' : '0');

        iframe.src = baseUrl + '?' + params.toString();
    }

    attached() {

        this.$waitlistModaleToggles = document.querySelectorAll('[waitlist-modale-toggle]');
        this.$waitlistModaleSteps   = this.querySelectorAll('[waitlist-modale-step]');
        this.$waitlistForm          = this.querySelector('[waitlist-form]');

        this.$waitlistModaleToggles?.forEach(el => {
            el.addEventListener('click', e => {
                if (this.isModaleOpened) {
                    this.closeModale();
                }
                else {
                    this.openModale();
                }
            });
        })

        this.$waitlistForm?.addEventListener('submit', e => {
            e.preventDefault();
            e.stopPropagation();
            this.onFormSubmit();
        });

        const params = new URLSearchParams(window.location.search);
        const waitlist = params.get('waitlist');
        if (waitlist || window.location.hash === '#waitlist') {
            this.openModale();
        }
            
    }

    openModale() {
        clearTimeout(this.hideTimer);
        this.isModaleOpened = true;
        this._buildIframeUrl();
        this.style.visibility = 'visible';
        requestAnimationFrame(()=>{
            this.style.opacity = 1;
            this.style.pointerEvents = 'auto';
        });
        this.updateFormStep('form');
        if (window.clarity) {
            window.clarity("set", "waitlist", "open");
        }
    }

    closeModale() {
        this.isModaleOpened = false;
        this.style.opacity = 0;
        this.style.pointerEvents = 'none';
        this.hideTimer = setTimeout(()=>{
            this.style.visibility = 'hidden';
        }, 1300); 
        if (window.clarity) {
            window.clarity("set", "waitlist", "close");
        }
    }

}

customElements.define('waitlist-modale', WaitlistModale);